import { StaticInterface } from '../../../helpers/static-interface';
import TpxCircleUtils from '../../atoms/shape/circle.utils';
import TpxTriangleUtils from '../../atoms/shape/triangle.utils';

export interface ITpxHeroUtils {
}

export interface IStaticHeroUtils {
  new (...args: any[]): ITpxHeroUtils;
  init(): void;
}

/**
 * Hero utilities
 * @class
 */
 export default class TpxHeroUtils implements StaticInterface<IStaticHeroUtils, typeof TpxHeroUtils> {
  /**
   * Adds the necessary event listeners to support parallax
   */
  static init() {
    [...document.getElementsByClassName('o-hero')].forEach(hero => {
      TpxCircleUtils.init(hero as HTMLElement);
      TpxTriangleUtils.init(hero as HTMLElement);
    });
  }
}